module.exports = __webpack_public_path__ + "img/PlanQ-Logo-Land.f64b9762.png";